import type { SourcingEventDto } from "../../../autogen/bff-api";
import { hasTenderStageQualification } from "../../sourcing-events/buyer/wizard/utils/procedure";
import { InterestInvitationCard } from "./InterestInvitationCard";
import { RequestQualificationTab } from "./RequestQualificationTab";
import { TenderQualificationTab } from "./tender/TenderQualificationTab";

interface Props {
  event: SourcingEventDto;
}

// Where the qualification happens follows the procedure: two-stage procedures qualify the
// forespørsler om å delta, single-stage ones qualify the delivered tenders.
export const QualificationTab = ({ event }: Props) => {
  const procedureType =
    event.eventContext.type === "Public" ? event.eventContext.procedureType : undefined;
  const call = event.eventContext.type === "Public" ? event.eventContext.priorInformationCall : null;
  if (call && !call.interestInvitedAt) return <InterestInvitationCard event={event} />;
  return hasTenderStageQualification(procedureType) ? (
    <TenderQualificationTab event={event} />
  ) : (
    <RequestQualificationTab event={event} />
  );
};
